import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import cartReducer from './cartSlice'; 
import searchReducer from "./searchSlice"; // Import searchSlice

const store = configureStore({
  reducer: {
    user: userReducer,
    cart: cartReducer, // Add your cart reducer here
    search: searchReducer, // Add search reducer
  },
});

// Infer the types of the RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;